/**
 * LotoConveniView.js
 * calss: LotoConveniView
 * class: ConveniCanvas
 */

function conveniInit(lotoCateg, resultObj) {

    let conveniV = new LotoConveniView(lotoCateg, resultObj);

};



class LotoConveniView {
    
    constructor(lotoCateg, lotoResult) {

        this.lotoCateg=lotoCateg;

        this.lotoBase = new LotoBase( lotoCateg, lotoResult );


        this.jikuBoo = MyUtility.makeFillArraySetVal( lotoCateg.numb+1, false, lotoCateg.numb, true);
        this.jyoBoo = MyUtility.makeFillArraySetVal( lotoCateg.numb+1, false, lotoCateg.numb, true);

        this.booArrayMap = new Map();
        this.booArrayMap.set( nominateCategory.JIKU, this.jikuBoo );
        this.booArrayMap.set( nominateCategory.JYOGAI, this.jyoBoo );

        this.bindBooArrayMap = new Map();
        this.bindBooArrayMap.set( nominateCategory.JIKU, this.jyoBoo );
        this.bindBooArrayMap.set( nominateCategory.JYOGAI, this.jikuBoo );

        this.selectMaxMap = new Map();
        this.selectMaxMap.set(nominateCategory.JIKU, 2);
        this.selectMaxMap.set(nominateCategory.JYOGAI, 3);

        this.booArrayResetIndex = this.lotoCateg.numb;

        //  target
        this.targetIndex = 1;
        this.targetNumbArray = lotoCategory.getTargetArray(this.lotoCateg);
        this.targetNumbArray.forEach( (val, ind) => document.getElementById("target-"+ind).textContent = val );

        // btStyle
        this.setNomiSelectBtSttyle(nominateCategory.JIKU);
        this.setNomiSelectBtSttyle(nominateCategory.JYOGAI);
        this.setTragetBtStyle();

        // canvas

        this.canvas = new ConveniCanvas();

        this.canvasSelectContList = [];
        this.selectContListIndex = 0;

        this.pickup3List = [];

        // navi back
        MyUtility.setElementStyle('custom', 'display', 'block');


        this.addEvent();

    };

    get targetCount() {   return this.targetNumbArray[ this.targetIndex ];   };


    // 現在のチェックボックスの状態をnomiDataPoolに反映
    setNomiPoolCheckBoXResult() {

        const nomiPool = this.lotoBase.nomiDataPool;

        const jikuCont = this.cleateNomiContentsForCheckBox( nominateCategory.JIKU );
        const jyoCont = this.cleateNomiContentsForCheckBox( nominateCategory.JYOGAI );

        nomiPool.nomiUserObjAddCheckBoxCont(jikuCont, jyoCont);

    };



    //  軸、除外、のチェックボックスの結果を格納したNomiContentsの作成
    cleateNomiContentsForCheckBox( nomiCateg ) {

        const booArr = this.booArrayMap.get(nomiCateg);

        let valArr = this.userSelectObjBooArryTrueValueNumbList(booArr);

        return new NomiContents( this.lotoCateg, nomiCateg, valArr );
    };
    userSelectObjBooArryTrueValueNumbList(booArray) {
        let result = [];
        booArray.forEach( (val, ind, arr) => {  if( ind<arr.length-1 && val ) { result.push(ind+1); };  } );
        return result;
    };


    checkBoxSelectBooArrayBt( nomiCateg, index ) {

        let booArr = this.booArrayMap.get(nomiCateg);
        let bindArr = this.bindBooArrayMap.get(nomiCateg);
        let max = this.selectMaxMap.get(nomiCateg);

        BooArrayController.selectBooArrayProcess( booArr, index, max, this.booArrayResetIndex );
        BooArrayController.bindBooArraySetProcess( booArr, bindArr, this.booArrayResetIndex );

        this.setNomiSelectBtSttyle(nominateCategory.JIKU);
        this.setNomiSelectBtSttyle(nominateCategory.JYOGAI);

    };
    


    //  targetBtProcess
    clickdTargetBtProcess(index) {
        this.targetIndex = index;
        this.setTragetBtStyle();
    };


    // navi bt
    naviReturnProcess() {

        const custom = document.getElementById('custom');
        const pred = document.getElementById('pred');
        const result = document.getElementById('result');

        if(custom.style['display']==='block') {

            window.history.back();

        }else if(pred.style['display']==='block') {

            this.lotoBase.nomiDataPoolResetAll();

            this.canvasSelectCountChange();

            MyUtility.setElementStyle('custom', 'display', 'block');
            MyUtility.setElementStyle('pred', 'display', 'none');

        }else if(result.style['display']==='block') {

            this.lotoBase.nomiDataPoolUserContListReset();

            this.canvasSelectCountChange();

            MyUtility.setElementStyle('custom', 'display', 'block');
            MyUtility.setElementStyle('result', 'display', 'none');
        }else {
            // スルー
        };
    };




    // event
    addEvent() {

        MyUtility.setElementEvent( 'process-return-bt', 'click', () => this.naviReturnProcess() );

        MyUtility.setElementEvent( 'custom-next-bt', 'click', () => this.customNextProcess() );

        this.setCheckBoxBtLisner(nominateCategory.JIKU);
        this.setCheckBoxBtLisner(nominateCategory.JYOGAI);

        this.setTargetCountBtListener();

        // canvas
        this.setCanvasSelectBtListener();
        MyUtility.setElementEvent( 'canvasBt-pass', 'click', () => this.canvasPassProcess() );
        MyUtility.setElementEvent( 'canvasBt-return', 'click', () => this.canvasReturnProcess() );

        // theme
        
        MyUtility.setElementEvent( 'theme-bt', 'click', () => this.canvasThemeChange() );
        
    };
    
    setCheckBoxBtLisner(nomiCateg) {
        let categ = nomiCateg.id;
        let booArr = this.booArrayMap.get( nomiCateg );

        for(let i=0, n=booArr.length; i<n; i++) {
            MyUtility.setElementEvent( categ+'-'+(i+1), 'click', () => this.checkBoxSelectBooArrayBt( nomiCateg, i ) );
        };
    };


    setTargetCountBtListener() {
        for(let i=0; i<3; i++) {
            MyUtility.setElementEvent( 'target-'+i, 'click', () => this.clickdTargetBtProcess(i) );
        };
    };



    // eventProcess

    customNextProcess() {

        this.setNomiPoolCheckBoXResult();

        if( this.setCanvasSelectContList( this.targetCount ) ) {
            this.pickup3List = this.pickup3ContList( this.canvasSelectContList, this.selectContListIndex );

            this.canvas.setViewContList( this.pickup3List );
    
            MyUtility.setElementStyle('custom', 'display', 'none');
            MyUtility.setElementStyle('pred', 'display', 'block');
        }else {

            this.resultDivView("custom")
        };
    };



    setCanvasSelectContList( targetCount ) {

        let material = this.lotoBase.getUserChoiceMaterial( targetCount );
        if( !! material ) {
            this.canvasSelectContList = material;
            return true;
        }else {
            return false;
        };
        
    };
    pickup3ContList(contList, index) {

        let resultList = [];
        if(contList.length<=3) {
            contList.forEach( e => resultList.push(e) );
        }else {
            for(let i=0; i<3; i++) {
                resultList.push( contList[(i+index)%contList.length] );
            };
        };
        return resultList;
    };




    // canvas
    setCanvasSelectBtListener() {
        for(let i=0; i<3; i++) {
            MyUtility.setElementEvent( 'canvasBt-'+i, 'click', () => this.canvasSelectBtProcess(i) );
        };
    };
    canvasSelectBtProcess(index) {

        if(this.pickup3List.length>index) {

            this.lotoBase.nomiDataPoolAddUserChoiceContents( this.pickup3List[index] );

            if( this.setCanvasSelectContList( this.targetCount ) ) {

                this.selectContListIndexReset();

                this.pickup3List = this.pickup3ContList( this.canvasSelectContList, this.selectContListIndex );
    
                this.canvas.setViewContList( this.pickup3List );

                this.canvasSelectCountChange();

            }else {

                this.resultDivView("pred");
            };
        };
    };

    canvasPassProcess() {

        this.selectContListIndexPass();

        this.pickup3List = this.pickup3ContList( this.canvasSelectContList, this.selectContListIndex );

        this.canvas.setViewContList( this.pickup3List );

    };
    selectContListIndexPass() {
        let len = this.canvasSelectContList.length;
        this.selectContListIndex = (this.selectContListIndex+3)%len;
    };
    selectContListIndexReset() {
        this.selectContListIndex = 0;
    };

    canvasReturnProcess() {

        this.lotoBase.nomiDataPoolUserContListPop();

        if( this.setCanvasSelectContList( this.targetCount ) ) {

            this.selectContListIndexReset();

            this.pickup3List = this.pickup3ContList( this.canvasSelectContList, this.selectContListIndex );

            this.canvas.setViewContList( this.pickup3List );

            this.canvasSelectCountChange();

        }else {

            this.resultDivView("pred");
        };
    };

    canvasSelectCountChange() {

        let selectCount = this.lotoBase.getNomiDataPoolSelectCount();
        let selectCountTd = document.getElementById( 'selectCount-val' );
        selectCountTd.textContent = selectCount;
    };

    // theme
    canvasThemeChange() {
        this.canvas.themeChange();
    };



    // result

    resultDivView(noneDivName) {

        const resultList = this.lotoBase.getResultNumber( this.targetCount );

        this.setResultTable( resultList );
        this.setResultListSize(resultList);

        MyUtility.setElementStyle( noneDivName , 'display', 'none');
        MyUtility.setElementStyle('result', 'display', 'block');

        window.scroll(0,98);
    }


    setResultTable( resultList ) {

        let result_td = document.getElementById('result-td');
        let frag = document.createDocumentFragment();
        for(let i=0, n=resultList.length; i<n; i++) {

            let numb = resultList[i];
            let ndA = document.createElement( 'a' );
            ndA.appendChild( document.createTextNode( numb ) );
            /*
			ndA.className='box-text';
			let nb34 = 'nb'+numb.length;
            ndA.href = '../numb-box/'+nb34+'/'+nb34+'-box-'+numb+'.html';
            */
            let sp = '';
            if(i<n-1) {   sp = ', ';   }
            frag.appendChild( ndA );
			frag.appendChild( document.createTextNode( sp ) );
        };

        let child = result_td.lastChild;
        while( child ) {
            result_td.removeChild(child);
            child = result_td.lastChild;
        };
        
        result_td.appendChild( frag );
    };

    setResultListSize(resultList) {
        let size = resultList.length;
        let td_size = document.getElementById( 'result-size' );

        let child = td_size.lastChild;
        while( child ) {
            td_size.removeChild(child);
            child = td_size.lastChild;
        };
        td_size.appendChild( document.createTextNode(size) );
    };





    //  DOM
    setNomiSelectBtSttyle(nomiCateg) {
        let categ = nomiCateg.id;
        let booArr = this.booArrayMap.get( nomiCateg );

        this.setSelectBtStyle( categ ,booArr );
    };

    setSelectBtStyle( categ ,booArr ) {
        for(let i=0, n=booArr.length; i<n; i++) {
            let bcColor = booArr[i] ? '#0077d0' : "#eeeeff";
            let color = booArr[i] ? '#ffffff' : "#0000aa";
            MyUtility.setElementStyle( categ+'-'+(i+1), 'background-color', bcColor );
            MyUtility.setElementStyle( categ+'-'+(i+1), 'color', color );
        };
    };

    setTragetBtStyle() {
        const arr = this.targetNumbArray;
        for(let i=0, n=arr.length; i<n; i++) {
            let bcColor = i===this.targetIndex ? '#0077d0' : "#eeeeff";
            let color = i===this.targetIndex ? '#ffffff' : "#0000aa";
            MyUtility.setElementStyle( 'target-'+i, 'background-color', bcColor );
            MyUtility.setElementStyle( 'target-'+i, 'color', color );
        };
    };

    // any porocess



};


class ConveniCanvas {

    constructor(themeIndex=0) {

        //  テーマ
		this._THEME_0 = { numb: 0,  white: 'white', back: 'rgba(92,168,239,1)', gradaB: [ 92,168,239 ],
                gradaItv: [ 32, 17, 3 ], back2: 'rgb(62, 148, 242)', graphBack: 'rgba(105, 188, 255, 0.85)',
                strokeLine: 'rgba(5, 25, 255, 0.8)', strokeGraphF: 'rgba(37, 53, 111, 0.95)',
                graphUp: 'rgba(50, 252, 90, 0.8)', graphDown: 'rgba(230, 210, 5, 0.8)',
                movingA_S: 'rgb(210, 85, 10)',  movingA_M: 'rgb( 255, 255, 255)',
                movingA_L: 'rgb(255,255,0)'  };

        this._THEME_1 = { numb: 1,  white: 'white', back: 'rgba(50,50,50,1)', gradaB: [ 50,50,50 ],
                gradaItv: [ 40, 40, 40 ], back2: 'rgb(25, 25, 25)', graphBack: 'rgba(70, 70, 70, 1)',
                strokeLine: 'rgba(10, 10, 10, 1)', strokeGraphF: 'rgba(5, 5, 5, 1)',
                graphUp: 'rgba(50, 252, 90, 0.8)', graphDown: 'rgba(230, 210, 5, 0.8)',
                movingA_S: 'rgb(10, 130, 240)',  movingA_M: 'rgb( 255, 255, 255)',
                movingA_L: 'rgb(230,230,0)'  };

        this._THEME_2 = { numb: 2,  white: 'rgb(30,30,30)', back: 'rgba(230,230,245,1)', gradaB: [ 240,240,255 ],
                gradaItv: [ -48, -48, -50 ], back2: 'rgb(215, 215, 235)', graphBack: 'rgba(180, 180, 200, 1)',
                strokeLine: 'rgba(10, 10, 10, 1)', strokeGraphF: 'rgba(145, 145, 205, 1)',
                graphUp: 'rgba(50, 252, 90, 0.8)', graphDown: 'rgba(230, 210, 5, 0.8)',
                movingA_S: 'rgb(10, 130, 240)',  movingA_M: 'rgb( 255, 255, 255)',
                movingA_L: 'rgb(255,255,0)'  };

        this._themeArray = [   this._THEME_0, this._THEME_1, this._THEME_2   ];
        this._themeIndex = themeIndex;
        this.setTheme( false );

        //
        this.viewContList = [];
    };


    themeChange() {
        this._themeIndex = (this._themeIndex+1)%this._themeArray.length;
        this.setTheme();
    };


    setTheme( isPaint = true ) {

        this._THEME = this._themeArray[ this._themeIndex ];
        this._setThemeColor();
        if(isPaint) {  this.paint();  }
        MyUtility.setElementStyle( 'centerLi_0', 'background-color', this._fillStyleBack );
        MyUtility.setElementStyle( 'centerLi_0', 'border-color', this._styleWhite );
        MyUtility.setElementStyle( 'canvasBt-table', 'background-color', this._fillStyleBack );
        MyUtility.setElementStyle( 'canvasBt-table-2', 'background-color', this._fillStyleBack );

        MyUtility.setElementStyle( 'selectCount-table', 'background-color', this._fillStyleBack );
        MyUtility.setElementStyle( 'selectCount-table', 'color', this._styleWhite );
        MyUtility.setElementStyle( 'selectCount-table', 'border-color', this._styleWhite );

        MyUtility.setElementStyle( 'theme-bt', 'background-color', this._fillStyleBack );
        MyUtility.setElementStyle( 'theme-bt', 'color', this._styleWhite );
        MyUtility.setElementStyle( 'theme-bt', 'border-color', this._styleWhite );

    };

    _setThemeColor() {

		this._styleWhite = this._THEME.white;
		this._fillStyleBack = this._THEME.back;
		this._gradationBase = this._THEME.gradaB;
		this._gradationItv = this._THEME.gradaItv;

		this._fillStyleBack2 = this._THEME.back2;
		this._fillStyleGraphBack = this._THEME.graphBack;

		this._strokeStyleLine = this._THEME.strokeLine;

		this._strokeStyleCenterGraphFrame = this._THEME.strokeGraphF;
		this._fillStyleCenterGraphUp = this._THEME.graphUp;
		this._fillStyleCenterGraphDown = this._THEME.graphDown;

		this._movingA_S = this._THEME.movingA_S;
		this._movingA_M = this._THEME.movingA_M;
		this._movingA_L = this._THEME.movingA_L;

	};



    setViewContList(contList) {
        this.viewContList = contList;
        this.paint();
    };


    paint() {

        let pick3 = this.viewContList;

		let canvas = document.getElementById( 'canvas' );

		if (canvas.getContext) {

			let context = canvas.getContext('2d');

			//  画面クリア
			context.fillStyle = this._fillStyleBack;
            context.fillRect(0, 0, 320, 450);

            
            context.fillStyle = this._fillStyleBack2;
            for(let i=0; i<3; i++) {
                for(let j=0; j<4; j++) {
                    context.fillRect(35+(i*95), 5+(j*100), 90, 50);
                }; 
            }

            //  枠
			context.strokeStyle = this._styleWhite;
			context.strokeRect(35, 5, 90, 400);
            context.strokeRect(130, 5, 90, 400);
            context.strokeRect(225, 5, 90, 400);


			//テキスト描画のスタイルを指定
			context.fillStyle = this._styleWhite;
			context.font = "13px 'Meiryo'";
			context.textAlign = "left";
            context.textBaseline = "top";
            

            let pick3Size = pick3.length;

            if(pick3Size >= 1) {
                let arr = pick3[0].booArray;
                this._leftNumbPaint( context, 0, arr.length-40, 40 );
                this._leftRectPaint( context, 0, arr, arr.length-40, 40, 0 );

                let per = pick3[0].percentFormat;
                this.percentPaint( context, per, 0 );
            };
            if(pick3Size >= 2) {
                let arr = pick3[1].booArray;
                this._leftRectPaint( context, 0, arr, arr.length-40, 40, 1 );

                let per = pick3[1].percentFormat;
                this.percentPaint( context, per, 1 );
            };
            if(pick3Size===3) {
                let arr = pick3[2].booArray;
                this._leftRectPaint( context, 0, arr, arr.length-40, 40, 2 );

                let per = pick3[2].percentFormat;
                this.percentPaint( context, per, 2 );
            };
            
		};
    };


    _leftNumbPaint( context, zz, indStart, range ) {
    
		let boxRange = 400/range;

		let fontSizeSub = range/50;
		let fontSize = Math.floor(boxRange*(0.25+fontSizeSub));

		context.font = fontSize+"px 'Meiryo'";

		for(let i=0; i<range; i++) {
			context.fillText((i+zz+indStart+1), 7, 4.5+i*boxRange, 55);
        };

        context.font = "12px 'Meiryo'";
        context.fillText((indStart+range+1), 5, 408, 55);

        context.font = "14px 'Meiryo'";
        context.fillText( '確率', 8, 430, 55);
        
	};

    _leftRectPaint( context, zz, arr, indStart, range, windowIndex ) {

		let boxRange = 400/range;
		let big = boxRange*0.75;
		let sml = boxRange*0.15;
		let bigG = (boxRange-big)/2;
		let smlG = (boxRange-sml)/2;

		let rangeX = boxRange/2;

		let fontSizeSub = range/50;
		let fontSize = Math.floor(boxRange*(0.25+fontSizeSub));

		context.font = fontSize+"px 'Meiryo'";

		for(let i=0; i<range; i++) {

			if(!arr[i+zz+indStart]) {
				context.fillRect(78+smlG-rangeX+(windowIndex*95), 5+smlG+i*boxRange, sml, sml);
			}else {
				context.fillRect(78+bigG-rangeX+(windowIndex*95), 5+bigG+i*boxRange, big, big);
            };
        };
        
        context.fillRect(78+bigG-rangeX+(windowIndex*95), 413, big, big);

        context.font = "12px 'Meiryo'";
        context.fillText( '?', 90+(windowIndex*95), 408, 55);
    };
    
    percentPaint( context, percent, windowIndex ) {

        context.font = "14px 'Meiryo'";
        context.fillText( percent+'%', 55+windowIndex*95, 430, 55);
    };
};